import React from "react"
import { SessionProvider } from "./src/context/SessionContext"

export const wrapRootElement = ({ element }) => (
    <SessionProvider>{element}</SessionProvider>
)
